import React from 'react';

interface IVignetteCZProps {
	className?: string;
	size?: string;
}

export const VignetteCZ = ({ className, size = '72' }: IVignetteCZProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} className={className} viewBox="0 0 72 72" fill="none">
			<rect width="72" height="72" rx="6" fill="#F4F4F4" />
			<rect
				x="11.25"
				y="11.25"
				width="49.5"
				height="49.5"
				rx="5.25"
				fill="white"
				stroke="#707070"
				strokeWidth="1.5"
			/>
			<rect x="14.25" y="14.25" width="43.5" height="43.5" rx="2.25" fill="#F4F4F4" />
			<path d="M32.25 24H35.25V48H26.25L32.25 24Z" fill="#A3A3A3" />
			<path d="M39.75 24H36.75V48H45.75L39.75 24Z" fill="#A3A3A3" />
			<rect x="25.5" y="30.75" width="21" height="4.5" fill="#A3A3A3" stroke="#F4F4F4" strokeWidth="1.5" />
			<ellipse cx="47.25" cy="21.75" rx="9" ry="6" fill="#ffcc00" />
			<path
				d="M45.4132 24.822C46.0972 24.822 46.4752 24.714 46.8442 24.552V23.454C46.5202 23.652 46.1242 23.787 45.5662 23.787C44.5942 23.787 44.0002 23.157 44.0002 22.014C44.0002 20.763 44.5402 20.106 45.5302 20.106C46.0882 20.106 46.5112 20.232 46.7812 20.394V19.323C46.4932 19.206 46.0702 19.071 45.3952 19.071C43.5592 19.071 42.6952 20.403 42.6952 22.014C42.6952 23.616 43.6132 24.822 45.4132 24.822ZM47.8147 24.75H51.8647V23.733H49.3447L51.7927 19.989V19.143H47.9137V20.16H50.3077L47.8147 23.94V24.75Z"
				fill="#121212"
			/>
			<path d="M3 60.75H64.5" stroke="#707070" strokeWidth="1.5" />
			<path d="M66.75 60.75L69 60.75" stroke="#707070" strokeWidth="1.5" />
		</svg>
	);
};
